import {
    Box, Text, Flex, Image, Heading, Button, HStack, VStack,
    Card, CardHeader, CardBody, IconButton, Icon
} from "@chakra-ui/react"
import { ChevronRightIcon } from '@chakra-ui/icons'
import { useState } from "react"
import { MdArrowOutward } from "react-icons/md";
import { motion, Variants } from "framer-motion"


export const ProjectsPage = () => {

    // Format for projectData
    // {
    //     author: "",
    //     projectName: "",
    //     subheading: "",
    //     date: "",
    //     description: "",
    //     projectTags: [],
    //     link: ""
    // },
    const container: Variants = {
        hidden: {
            y: 300,
            opacity: 0
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                type: "spring",
                bounce: 0.4,
                duration: 0.8,
                delayChildren: 0.3,
                staggerChildren: 0.2
            }
        }
    };

    const items: Variants = {
        hidden: {
            y: 25,
            opacity: 0
        },
        show: {
            opacity: 1,
            y: 0,
        }
    }


    const [currentProject, setCurrentProject] = useState(-1)

    const projectData = [
        {
            author: "AHMED IMANA",
            projectName: "CASHFLOW",
            subheading: "Finance and budget managment app.",
            date: "October 2023",
            description: "This was project all about combining the concept of 'Cashflow' with a simple, easy-to-use, web application.",
            projectTags: ["React", "Chakra UI", "HTML", "Javascript"],
            link: "https://github.com/meguta/cashflow",
            imgSrc: "cashflow-img.png"
        },
        {
            author: "AHMED IMANA",
            projectName: "WORDTOANKI",
            subheading: "Automatic flashcard generator and study tool.",
            date: "November 2023",
            description: "Wordtoanki is an web application that helps students study more effectively and save time while studying. It utilizes study techniques, such as active recall, and spaced repetition in order for maxmial study effectiveness.",
            projectTags: ["React", "Chakra UI", "HTML", "Javascript"],
            link: "https://github.com/meguta/wordtoanki",
            imgSrc: "wordtoanki-img.png"
        }
    ]

    function displayProjects() {
        if (currentProject !== -1) {
            const projectMap = [projectData[currentProject]]

            return projectMap.map(proj =>
        
            <motion.div variants={container} whileInView="show" initial="hidden" viewport={{ once: true }}>
                <Flex pt="7rem" id={"PROJ" + currentProject.toString()} width="100%" bg="background" direction="column" justifyContent="center">
                    <VStack
                        bg="container_bg"
                        px="2rem" pt="2rem" pb="1.5rem" borderRadius="20px" margin="1rem auto" width="90%"
                        border="solid 0.5px var(--chakra-colors-container_outline)"
                        boxShadow="0px 0px 8px 0px var(--chakra-colors-container_shadow)"
                        direction="column" textAlign="left" alignItems="left">
                        <Heading as={motion.div} variants={items} variant="special" fontSize="18px" color="body_text_alt" letterSpacing=".45em">{proj.author}</Heading>
                        <Heading as={motion.div} variants={items} variant="special" fontSize="24px" color="accent">{proj.projectName}</Heading>
                        <Heading as={motion.div} variants={items} variant="subheading" fontWeight="medium">{proj.subheading}</Heading>
                        <Flex as={motion.div} variants={items} bg="container_bg_alt" rounded="10px" width="100%" padding="1rem" justifyContent='center'>
                            <Image rounded="5px" boxShadow="0px 0px 2px 0px #00000020" src={proj.imgSrc} />
                        </Flex>
                        <Text as={motion.div} variants={items} variant="body" color="body_text_alt">{proj.date}</Text>
                        <Text as={motion.div} variants={items} variant="body">{proj.description}</Text>

                        <HStack as={motion.div} variants={items} bg="container_bg_alt" rounded="10px" width="100%" overflowX="scroll" padding="1rem" whiteSpace="nowrap">
                            {proj.projectTags.map(tag => <Text variant="tag">{tag}</Text>)}
                        </HStack>
                        <Button as={motion.div} variants={items} role="group" variant="moreinfo" alignSelf="center" onClick={() => {
                            window.open(proj.link, '_blank')
                        }}>
                            <Box pr="1rem">READ MORE</Box>
                            <ChevronRightIcon color="#FF9820" transition="0.25s" boxSize={8} _groupHover={{ boxSize: "10" }} />
                        </Button>
                    </VStack>
                </Flex>
            </motion.div>

            )
        } else {
            return 
        }
    }

    return (
        <motion.div variants={container} whileInView="show" initial="hidden" viewport={{ once: true }}>
            <Flex pt="7rem" id="PROJECTS" width="100%" bg="background" direction="column" justifyContent="center" textAlign="left">
                <VStack
                    bg="container_bg"
                    px="2rem" pt="2rem" pb="1.5rem" borderRadius="20px" margin="1rem auto" width="90%"
                    border="solid 0.5px var(--chakra-colors-container_outline)"
                    boxShadow="0px 0px 8px 0px var(--chakra-colors-container_shadow)"
                    direction="column"
                    alignItems="left">
                    <Box as={motion.div} variants={items} mb="1.5rem">
                        <Heading variant="special" as="span">PROJECTS</Heading>
                        <Heading variant="special" as="span" color="#FF9820" >.</Heading>
                    </Box>
                    <Text as={motion.div} variants={items}  variant="body">Here you will find my portfolio with my recent works, demonstrating elements of web development and design.
                    </Text>
                    <VStack bg="container_bg_alt" rounded="10px" width="100%" padding="1rem">
                        <Card as={motion.div} variants={items}  variant="project" role="group">
                            <CardHeader>
                                <HStack justifyContent="space-between">
                                    <Heading variant="special" fontSize="18px">CASHFLOW</Heading>
                                    <IconButton onClick={() => {
                                        setCurrentProject(0)
                                        document.getElementById("PROJ")?.scrollIntoView({behavior: "smooth"})
                                        }} isRound variant="iconbutton" aria-label="go to project" icon={<Icon boxSize="1.2rem" transition="0.25s" _groupHover={{boxSize: "1.6rem"}} as={MdArrowOutward}/>}/>

                                </HStack>
                            </CardHeader>
                            <CardBody>
                                <Text variant="body">An app to manage your finances.</Text>
                            </CardBody>
                        </Card >
                        <Card as={motion.div} variants={items} variant="project">
                            <CardHeader>
                                <HStack justifyContent="space-between">
                                    <Heading variant="special" fontSize="18px">WORDTOANKI</Heading>
                                    <IconButton onClick={() => {
                                        setCurrentProject(1)
                                        document.getElementById("PROJ")?.scrollIntoView({behavior: "smooth"})
                                        }} isRound variant="iconbutton" aria-label="go to project" icon={<Icon boxSize="1.2rem" transition="0.25s" _groupHover={{boxSize: "1.6rem"}} as={MdArrowOutward}/>}/>

                                </HStack>
                            </CardHeader>
                            <CardBody>
                                <Text variant="body">Automatic flashcard generator and study tool.</Text>
                            </CardBody>
                        </Card>
                    </VStack>

                </VStack>
            </Flex>
            <Box id="PROJ">
                {displayProjects()}
            </Box>
        </motion.div>
    )
}